import React from "react";
import JobListing from "./JobCard";

function Vacancies() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-10">
      <div className="mx-auto max-w-7xl space-y-6">
        {/* <section className="rounded-3xl bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 p-8 text-white shadow-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-100">
            Careers
          </p>
          <h1 className="mt-3 text-3xl font-semibold text-white sm:text-4xl">
            Current Vacancies
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-6 text-blue-100 sm:text-base">
            Explore open teaching and administrative roles at Rising Stars Public
            School. Select a role, review details, and apply online.
          </p>
        </section> */}

        <section className="rounded-3xl border border-slate-200 bg-white p-4 shadow-md sm:p-6">
          <JobListing />
        </section>
      </div>
    </div>
  );
}

export default Vacancies;
